import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const {defineMultiStyleConfig} = createMultiStyleConfigHelpers([
  'content',
  'contentBody',
]);

/** Simple PDP inline customize shell — scoped separately from ConfigurationSelector dialog/flyout. */
const CustomizeStepsInline = defineMultiStyleConfig({
  baseStyle: {
    content: {
      width: '100%',
    },
    contentBody: {
      border: 'none',
      borderWidth: 0,
      flex: 1,
      minHeight: 0,
      overflowY: 'auto',
      padding: 0,
      paddingBottom: 0,
      paddingTop: {base: '40px', lg: '24px'},
      paddingX: 0,
      paddingY: 0,
      sx: {
        '& .customize-steps-step-divider': {
          display: 'none',
        },
        '& .customize-steps-main-view-step': {
          marginBottom: {base: '56px', lg: '64px'},
          paddingBottom: {base: '56px', lg: '64px'},
          borderBottom: '2px solid',
          borderColor: 'grayAlpha.10',
          '&:last-child': {
            marginBottom: 0,
            paddingBottom: 0,
            borderBottom: 'none',
          },
          '& > .chakra-text': {
            marginBottom: {base: '16px', lg: '16px'},
          },
          '& .chakra-stack slot-card-content-text': {
            gap: {base: '4px', lg: '4px'},
          },
          '& .slot-card-content-text-empty-slot-label': {
            fontSize: {base: '13px', lg: '13px'},
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '120%',
          },
          '& .slot-card-content-text-empty-title': {
            fontSize: {base: '14px', lg: '16px'},
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '140%',
          },
        },
      }
    },
  },
});

export default CustomizeStepsInline;
